import { Locales } from 'app/config/locales';

const NumberUtil = {
  roundToDecimals(value: number | string, decimals: number = 2) {
    return parseFloat(value.toString()).toFixed(decimals);
  },
  format(
    number: number,
    options?: Intl.NumberFormatOptions & { locales?: string | string[] },
  ) {
    const formatOptions = {
      maximumFractionDigits: 0,
      ...options,
    };
    const absoluteFormatted = Math.abs(number).toLocaleString(
      options?.locales,
      formatOptions,
    );
    if (
      absoluteFormatted === (0).toLocaleString(options?.locales, formatOptions)
    ) {
      return absoluteFormatted;
    }
    return number.toLocaleString(options?.locales, formatOptions);
  },
  randomInteger(min: number, max: number) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  },
  clamp(value: number, minValue: number, maxValue: number) {
    return Math.max(minValue, Math.min(value, maxValue));
  },
  compact(value: number) {
    return NumberUtil.format(value, {
      maximumFractionDigits: 2,
      notation: 'compact',
      compactDisplay: 'short',
      locales: Locales.EN_US,
    });
  },
  coalesceFinite(raw: unknown): number | undefined {
    if (raw == null) {
      return undefined;
    }
    if (typeof raw === 'number' && Number.isFinite(raw)) {
      return raw;
    }
    const n = Number(String(raw).trim());
    return Number.isFinite(n) ? n : undefined;
  },
};

export default NumberUtil;
